export const supportHeader = {
    aboutTheService: 'About the service',
    howToUse: 'How to use',
    glossary: 'Glossary',
    selectLang: 'ENGLISH'
}
